var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"job-wizard-section"},[(_vm.title !== '')?_c('p',{staticClass:"job-wizard-section__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.subtitle !== '')?_c('p',{staticClass:"job-wizard-section__subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }